import { ShieldAlert } from "lucide-react";
import { TakedownActions } from "@/components/shared/takedown-actions";
import { EntityHeader } from "./entity-header";

export function EntityRemovedCard({ alertId }: { alertId?: string }) {
  return (
    <div className="flex items-center gap-4 rounded-lg p-3">
      <div className="flex h-20 w-16 shrink-0 items-center justify-center rounded-md bg-surfaces-z3">
        <ShieldAlert className="size-7 text-text-tertiary" strokeWidth={1.5} />
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <span className="font-bold text-primary">Content removed</span>
        <p className="truncate text-sm text-tertiary">
          This content was removed for a safety concern.
        </p>
        <TakedownActions alertId={alertId} />
      </div>
    </div>
  );
}

interface EntityRemovedPanelProps {
  title?: string;
  alertId?: string;
  pagination?: {
    current: number;
    total: number;
    isLoadingNextPage?: boolean;
    onPrevious?: () => void;
    onNext?: () => void;
  };
}

export function EntityRemovedPanel({
  title,
  alertId,
  pagination,
}: EntityRemovedPanelProps) {
  return (
    <div className="flex h-full flex-col bg-white">
      <EntityHeader title={title} pagination={pagination} />
      <div className="flex flex-1 flex-col items-center justify-center gap-3 px-6">
        <ShieldAlert className="size-10 text-text-tertiary" strokeWidth={1.5} />
        <div className="flex flex-col items-center gap-1 text-center">
          <span className="text-lg font-bold text-primary">Content removed</span>
          <p className="max-w-xs text-sm text-tertiary">
            This content was removed for a safety concern.
          </p>
        </div>
        <TakedownActions alertId={alertId} />
      </div>
    </div>
  );
}
